import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Iconify from "../Iconify";
import { IconButton } from "@mui/material";
import { buttonCancelText } from "../../utils/cssStyles";

export interface ModalProps {
  title: any;
  onOk?: any;
  onCancel?: any;
  okLabel?: string;
  cancelLabel?: string;
  secondaryActionLabel?: string;
  onSecondaryAction?: any;
  message?: string | null;
  children?: any;
  isLoading?: boolean;
  okIcon?: string;
  okSX?: any;
  secondaryActionIcon?: string;
  secondaryActionSX?: any;
  fullScreen?: boolean;
  hideCancel?: boolean;
  isBig?: boolean;
  width?: string;
}

export default ({
  title,
  onOk,
  onCancel,
  okLabel,
  cancelLabel,
  secondaryActionLabel,
  onSecondaryAction,
  message,
  children,
  isLoading,
  okIcon,
  okSX = {},
  secondaryActionIcon,
  secondaryActionSX = {},
  fullScreen = false,
  hideCancel = false,
  isBig = false,
  width,
}: ModalProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const fs = fullScreen ? true : useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      fullScreen={fs}
      open={true}
      onClose={onCancel ? onCancel : null}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
        style: {
          ...(fs
            ? {}
            : width
              ? { maxWidth: width === "auto" ? "none" : width, width }
              : isBig
                ? { minWidth: "90vw", width: "90vw" }
                : { minWidth: "40vw", width: "40vw" }),
          overflow: "visible",
        },
      }}
    >
      <DialogTitle
        id="responsive-dialog-title"
        // sx={{ borderBottom: "1px solid #CCC" }}
        sx={{ position: "relative" }}
      >
        <div style={{ marginRight: "15px" }}>{title}</div>
        {onCancel && (
          <IconButton
            edge="start"
            color="inherit"
            onClick={onCancel}
            aria-label="close"
            sx={{
              // float: "right",
              fontWeight: "bold",
              // marginTop: "-15px",
              marginLeft: 0,
              position: "absolute",
              right: 0,
              top: 0,
            }}
            size="small"
          >
            <Iconify
              icon={"ep:close-bold"}
              width={20}
              sx={{ color: "error.dark" }}
            />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        {children ? children : <DialogContentText>{message}</DialogContentText>}
      </DialogContent>
      {(onOk || (onCancel && !hideCancel) || onSecondaryAction) && (
        <DialogActions>
          {onCancel && !hideCancel && (
            <Button
              disabled={isLoading}
              onClick={onCancel}
              size="small"
              sx={buttonCancelText}
            >
              {cancelLabel ? cancelLabel : t("Cancel")}
            </Button>
          )}
          {onSecondaryAction && (
            <LoadingButton
              loading={isLoading}
              loadingPosition="start"
              startIcon={
                secondaryActionIcon &&
                secondaryActionIcon.length > 0 && (
                  <Iconify icon={secondaryActionIcon} />
                )
              }
              variant="contained"
              sx={secondaryActionSX}
              onClick={onSecondaryAction}
              size="small"
            >
              {secondaryActionLabel ? secondaryActionLabel : t("Ok")}
            </LoadingButton>
          )}
          {onOk && (
            <LoadingButton
              loading={isLoading}
              loadingPosition="start"
              startIcon={
                okIcon && okIcon.length > 0 && <Iconify icon={okIcon} />
              }
              variant="contained"
              sx={okSX}
              onClick={onOk}
              size="small"
              autoFocus
            >
              {okLabel ? okLabel : t("Ok")}
            </LoadingButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};
